import { useState } from 'react';
import React from 'react'
import { Row, Col, Card, CardBody, CardHeader, Button, Collapse, Table, FormGroup, Label, Input } from 'reactstrap';
import { FaChevronUp, FaChevronDown, FaChevronRight, FaFilePdf, FaFileExcel } from 'react-icons/fa';
import uuid from 'react-uuid';
import moment from "moment";
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { apiGet,apiPost } from "../Utilities/Hooks/apiWrapper";

const FarmList = ({ farmsList, tempFarmsList, totalFarmDetails, itemModel, handleWizardFarmChanged, userId }) => {
    const [isOpen, setIsOpen] = useState(true);
    const [isIconUp, setIsIconUp] = useState(true); 
    const [name, setName] = useState('');
    const [farmItems, setFarmItems] = useState(farmsList);
    const toggle = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };

    const handleSetFarm = async (e, id) => {
        e.preventDefault();
        const farmId = parseInt(id);
        try {
            const response = await apiGet(
                '/api/settings/getFarmDetail/', {
                params: { farmId: farmId, userId: userId }
            }
            );
            localStorage.setItem("defaultFarmId", JSON.stringify(id));
            localStorage.setItem("defaultFarmName", JSON.stringify(response.data.name));
            localStorage.setItem("defaultFarmUniqueId", JSON.stringify(response.data.uniqueIdentifier));
            localStorage.setItem("isAddArchiveItem", response.data.isAddArchiveItem);
            localStorage.setItem("isAddEditItem", response.data.isAddEditItem);
            localStorage.setItem("isCreateNewAction", response.data.isCreateNewAction);
            localStorage.setItem("isSubmitEvidenceCloseAction", response.data.isSubmitEvidenceCloseAction);
            localStorage.setItem("isAddDeleteDocument", response.data.isAddDeleteDocument);
            localStorage.setItem("saveRightsForNonItemFieldsAndTables", response.data.saveRightsForNonItemFieldsAndTables);
            handleWizardFarmChanged(farmId);
        } catch (err) {
            if (err?.response) {
                toast.error("No server response");
            }
        }
    }

    const handleChangeName = async (event) => {
        setName(event.target.value);
        if (event.target.value == '') {
            setFarmItems(tempFarmsList);
        }
        else {
            var list = [];
            list = tempFarmsList.filter(x => (x.name.toLowerCase().includes(event.target.value.toLowerCase()) || (x.uniqueIdentifier != null ? x.uniqueIdentifier.toLowerCase().includes(event.target.value.toLowerCase()) : 0 ) ));
            setFarmItems(list);
        }
    }

    const exportFarmListToExcel = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleExportReportExcel();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handleExportReportExcel = async (e) => {
        const response = await apiGet(
            '/api/allFarmsSummary/GenerateReportFarmListExcel/', {
                params: { userId: userId }
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/vnd.ms-excel" })

            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "FarmList.xlsx";
            document.body.appendChild(link)
            link.click()
        }

    }

    const exportFarmListToPdf = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleExportReportPdf();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handleExportReportPdf = async (e) => {
        const response = await apiGet(
            '/api/allFarmsSummary/GenerateReportFarmListPDF/', {
                params: { userId: userId }
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/pdf" })
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "FarmList.pdf";
            document.body.appendChild(link)
            link.click()
        }

    }

    const base64ToArrayBuffer = (data) => {
        var binaryString = window.atob(data);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    const useSortableData = (items, config = null) => {
        const [sortConfig, setSortConfig] = React.useState(config);
        if (sortConfig == null) {
            setSortConfig({ key: 'name', direction:'ascending' });
        }
        const sortedItems = React.useMemo(() => {
            let sortableItems = [...items];
            if (sortConfig !== null) {
                sortableItems.sort((a, b) => {
                    if (a[sortConfig.key] < b[sortConfig.key]) {
                        return sortConfig.direction === 'ascending' ? -1 : 1;
                    }
                    if (a[sortConfig.key] > b[sortConfig.key]) {
                        return sortConfig.direction === 'ascending' ? 1 : -1;
                    }
                    return 0;
                });
            }
            return sortableItems;
        }, [items, sortConfig]);

        const requestSort = (key) => {
            let direction = 'ascending';
            if (
                sortConfig &&
                sortConfig.key === key &&
                sortConfig.direction === 'ascending'
            ) {
                direction = 'descending';
            }
            setSortConfig({ key, direction });
        };

        return { items: sortedItems, requestSort, sortConfig };
    };
    const ProductTable = (props) => {
        const { items, requestSort, sortConfig } = useSortableData(props.products);
        const getClassNamesFor = (name) => {
            if (!sortConfig) {
                return;
            }
            return sortConfig.key === name ? sortConfig.direction : undefined;
        };
        return (
            <Table striped bordered hover style={{  width: '100%' }}>
                <thead className="text-left">
                    <tr>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('name')}
                                className={getClassNamesFor('name')}
                            >
                                Name
                            </button>
                        </th>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('farmOperator')}
                                className={getClassNamesFor('farmOperator')}
                            >
                                Farm Operator
                            </button>
                        </th>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('ruralProfessional')}
                                className={getClassNamesFor('ruralProfessional')}
                            >
                                Rural Professional (if any)
                            </button>
                        </th>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('uniqueIdentifier')}
                                className={getClassNamesFor('uniqueIdentifier')}
                            >
                                Farm Identifier
                            </button>
                        </th>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('fepCreatedDate')}
                                className={getClassNamesFor('fepCreatedDate')}
                            >
                                Created On
                            </button>
                        </th>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('fepLastUpdatedDate')}
                                className={getClassNamesFor('fepLastUpdatedDate')}
                            >
                                Last Updated On
                            </button>
                        </th>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('status')}
                                className={getClassNamesFor('status')}
                            >
                                Status
                            </button>
                        </th>
                        <th>
                            # Open Actions
                        </th>
                        <th>
                                View
                        </th>
                    </tr>
                </thead>
                <tbody className="text-left">
                    {items.map((item) => (
                        <tr key={uuid()}>
                            <td>{item.name} </td>
                            <td>{item.farmOperator} </td>
                            <td>{item.ruralProfessional}</td>
                            <td>{item.uniqueIdentifier}</td>
                            <td>{item.fepCreatedDate != null ? moment(item.fepCreatedDate).format("DD/MM/YYYY") : ""}</td>
                            <td>{item.fepLastUpdatedDate != null ? moment(item.fepLastUpdatedDate).format("DD/MM/YYYY") : ""}</td>
                            <td>{item.status}</td>
                            <td>{item.openActions}</td>
                            <td>
                                <Button id={item.id} color="success" onClick={(e) => handleSetFarm(e, item.id)}> <FaChevronRight /></Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        );
    };
    return (
        <div>
            <Row style={{ marginTop: `15px` }}>
                <Col>
                    <Card>
                        <CardHeader className="item-header item_click" onClick={toggle}>
                            <Row>
                                <Col sm="11">
                                    <h6>Farm List
                                        <Button style={{ float: "right", background: "none", border: "none" }} onClick={(e) => exportFarmListToExcel(e)} value="Export" placeholder="">
                                            <img src="/images/Excel_icon.png" className="card_icon" ></img>
                                        </Button>
                                        
                                        {/*<Button style={{ float: "right", background: "none", border: "none", marginRight: "-20px" }} onClick={(e) => exportFarmListToPdf(e)} value="Export" placeholder="">*/}
                                        {/*    <img src="/images/PDF_icon.png" className="card_icon" ></img>*/}
                                        {/*</Button>*/}
                                    </h6>
                                </Col>
                                <Col sm="1" className="toggleoutline">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Collapse isOpen={isOpen}>
                                <div> 
                                    <Row>
                                     
                                    <Table striped bordered hover style={{ tableLayout: 'fixed', width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th># Total Farms</th>
                                                <th>Total HA</th>
                                                <th>Total KM perimeter</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr key={uuid()}>
                                                <td>{totalFarmDetails.totalFarms} </td>
                                                <td>{totalFarmDetails.totalFarmArea.toFixed(2)}</td>
                                                <td>{totalFarmDetails.totalFarmPerimeter.toFixed(2)}</td>
                                            </tr>
                                        </tbody>
                                        </Table>
                                    </Row>
                                    <Row style={{ marginTop:"10px" }}>
                                        <Col md="9">
                                        </Col>
                                        <Col md="3">
                                            <FormGroup>
                                                <Label style={{ textTransform: "none", fontSize: "medium" }}>Search</Label>
                                                <Input className="validate" type="text" value={name} onChange={handleChangeName} name="Name" id="Name" placeholder="" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                   
                                    <ProductTable
                                        products={farmItems}
                                    />
                                </div>
                            </Collapse>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}
export default FarmList;